import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.nrichadmin.admin.tokens');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-nrichadmin-admin-tokens',
template: templateSource || '',
    styles: [``],
})
export class PortalNrichadminAdminTokensComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public period: string = 'daily';
    public periods: string[] = ['daily', 'weekly', 'monthly'];
    public periodLabels: any = { daily: '일별', weekly: '주별', monthly: '월별' };
    public data: any[] = [];
    public loading: boolean = true;

    public async ngOnInit() {
        await this.service.init();
        await this.load();
        await this.service.render();
    }

    public async load() {
        this.loading = true;
        await this.service.render();
        const { code, data } = await wiz.call("token_usage", { period: this.period });
        if (code === 200) {
            this.data = Array.isArray(data) ? data : [];
        }
        this.loading = false;
        await this.service.render();
    }

    public async changePeriod(p: string) {
        this.period = p;
        await this.load();
    }

    public get totalTokens(): number {
        return this.data.reduce((sum, d) => sum + (d.tokens || 0), 0);
    }

    public get totalCost(): number {
        return this.data.reduce((sum, d) => sum + parseFloat(d.estimated_cost || 0), 0);
    }

    public get avgProcessingTime(): number {
        if (this.data.length === 0) return 0;
        const sum = this.data.reduce((s, d) => s + (d.avg_processing_time_ms || 0), 0);
        return Math.round(sum / this.data.length);
    }

    public get totalErrors(): number {
        return this.data.reduce((sum, d) => sum + (d.error_count || 0), 0);
    }

    public formatNumber(n: number): string {
        if (n >= 1000000) return (n / 1000000).toFixed(1) + 'M';
        if (n >= 1000) return (n / 1000).toFixed(1) + 'K';
        return String(n);
    }

    public barHeight(row: any): number {
        const max = Math.max(...this.data.map(d => d.tokens || 0), 1);
        return Math.max(4, Math.round(((row.tokens || 0) / max) * 100));
    }
}

export default PortalNrichadminAdminTokensComponent;